import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import App from './App';
import Insights from './services/insightsService';
import { networkDebugger } from './utils/networkDebugger';
import './index.css';

// Initialize Application Insights
Insights.initialize();

// Enable network debugger in development
if (import.meta.env.DEV) {
  networkDebugger.enable();
}

// Loading component for PersistGate
const PersistLoading = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    fontSize: '18px',
    color: '#007AFF'
  }}>
    Restoring session...
  </div>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<PersistLoading />} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);